import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

export default function BasketDealProductMetaItem({
  hidden,
  label,
  primary,
  className,
  children,
  textStrike,
}) {
  const theme = useContext(ThemeContext);
  if (hidden) {
    return null;
  }

  return (
    <>
      <div
        className={classNames(
          'meta-item',
          { 'meta-item--primary': primary },
          className,
        )}
      >
        <h3 className="meta-item__label">{label}</h3>
        <div
          className={classNames('meta-item__value', { 'cut-text': textStrike })}
        >
          {children}
        </div>
      </div>
      <style jsx>{`
        .meta-item {
          min-width: 16%;
          text-align: center;
          text-transform: ${theme.text.transform};
          padding: 0 15px;
          flex-basis: 0;
        }
        .meta-item__label {
          font-size: inherit;
          font-weight: bold;
          margin-bottom: 4px;
        }
        .meta-item__value {
          display: flex;
          align-items: center;
          position: relative;
          justify-content: center;
          font-size: 20px;
          margin: 0;
        }
        .meta-item--primary .meta-item__value {
          color: ${theme.colors.primary};
        }
        .cut-text:before {
          position: absolute;
          content: '';
          left: 0;
          top: 50%;
          right: 0;
          width: 80%;
          margin-left: 10%;
          border-top: 1px solid;
          -webkit-transform: rotate(-11deg);
          -ms-transform: rotate(-11deg);
          transform: rotate(-11deg);
        }
        @media (max-width: ${theme.breakpoints.xlDown}) {
          .meta-item {
            min-width: 20%;
          }
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          .meta-item {
            flex-grow: 1;
          }
        }
        @media (max-width: ${theme.breakpoints.smUp}) {
          .meta-item {
            padding: 0 5px;
          }
        }
      `}</style>
    </>
  );
}

BasketDealProductMetaItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  label: PropTypes.string,
  primary: PropTypes.bool,
  textStrike: PropTypes.bool,
};
